require('./brokerDataItem.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordLinkV2 } = require("utilities/tagging");

// @components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const privateIcon = require("assets/images/info-icon.svg");
const ccIcon = require('assets/images/icon-tutorial.svg');

class BrokerDataItem extends React.Component {
    taggingEvent() {
        const { eventCategory, eventTag } = this.props;
        if (!!eventCategory && !!eventTag) {
            recordLinkV2({
                categoriaEvento: eventCategory,
                accionEvento: "tooltip",
                etiquetaEvento: eventTag,
            });
        }
    }

    buildComplexTooltip(key) {
        return <FormattedText value={key} />;
    }

    render() {
        const {
            data,
            label,
            tooltipContentKey,
            tooltipTitleKey,
            complexTooltip,
        } = this.props;
        const tooltipIcon = __CONTACT_CENTER__ ? ccIcon : privateIcon;
        const tooltipTarget = (
            <img
                className="broker-data-item__item-tooltip"
                onMouseEnter={() => this.taggingEvent()}
                src={tooltipIcon}
            ></img>
        );
        const Tooltip = tooltipContentKey ? (
            <OKTooltip
                title={
                    !complexTooltip &&
                    !!tooltipTitleKey &&
                    formatText(tooltipTitleKey)
                }
                content={
                    complexTooltip
                        ? this.buildComplexTooltip(tooltipContentKey)
                        : formatText(tooltipContentKey)
                }
                placement="top"
                type={complexTooltip ? "custom" : "explicative"}
                target={tooltipTarget}
                offset={[0, -15]}
            />
        ) : null;
        return (
            <div className="broker-data-item__item">
                <span className="broker-data-item__label">
                    <FormattedText value={label} />
                    {Tooltip}
                </span>
                <span className="broker-data-item__item-data">{data}</span>
            </div>
        );
    }
}


BrokerDataItem.defaultProps = {
    eventTag: null,
    eventCategory: null,
    complexTooltip: false,
}

BrokerDataItem.propTypes = {
    data: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    tooltipTitleKey: PropTypes.string,
    tooltipContentKey: PropTypes.string,
    eventTag: PropTypes.string,
    eventCategory: PropTypes.string,
    complexTooltip: PropTypes.bool,
}

module.exports = BrokerDataItem;
